import React from "react";

export default function BeverageLabel({ name, sizeInCl, abv }) {
  const descriptionId = `description-${name}`; // Ensure uniqueness if multiple beverages

  return (
    <div id={descriptionId} className="mt-2 flex flex-col cursor-default">
      <span className="text-gray-900 tracking-tight text-sm">
        {name} ({sizeInCl}cl)
      </span>
      <span className="text-gray-700 tracking-tight text-sm">{abv}% vol</span>
    </div>
  );
}
